(() => {
  'use strict';
  if (window.AvonticBulkOrders) return;
  const parse = node => { try { return JSON.parse(node?.textContent || 'null'); } catch { return null; } };
  const put = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const interpolate = (value, data) => Object.entries(data).reduce((text, [key, item]) => text.replaceAll(`__${key.toUpperCase()}__`, String(item)), value || '');
  const integer = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 && Number(value) <= 100000;
  const units = (handle, variant) => !handle.includes('teamready') ? 1 : /-5-packs/.test(handle) || /5[- ](?:case|pack)/i.test(variant?.title || variant?.options?.join(' ') || '') ? 5 : 3;
  const current = strip => {
    const form = document.getElementById(strip.dataset.formId);
    const root = strip.closest('#avontic-primary-product, [data-station-root]') || strip.parentElement;
    const input = form?.elements.namedItem('id');
    const quantityInput = form?.elements.namedItem('quantity');
    const quantity = quantityInput ? Number(quantityInput.value) : 1;
    let validQuantity = integer(quantity) && (!quantityInput || quantityInput.checkValidity());
    const picker = [...root.querySelectorAll('variant-picker')].find(p => p.getAttribute('form-id') === strip.dataset.formId);
    const variant = picker ? parse(picker.querySelector('script[data-variant]')) : parse(strip.querySelector('[data-av17-bulk-variant]'));
    const stationPending = root.matches('[data-station-root]') && !root.querySelector('[data-station-option][data-kind="model"]')?.value;
    const fitPending = form?.dataset.avPurchaseFit === 'pending' || (picker && [...picker.querySelectorAll('[data-av-explicit-selection-option] select')].some(select => !select.value));
    const selected = input && !input.disabled && /^\d+$/.test(input.value) && variant && String(variant.id) === String(input.value) && !stationPending && !fitPending;
    const packSize = units(strip.dataset.productHandle, variant);
    validQuantity = validQuantity && integer(quantity * packSize);
    return {form, variant: selected ? variant : null, quantity, validQuantity, packSize, devices: quantity * packSize};
  };
  const href = (strip, state, placement) => {
    const url = new URL(strip.dataset.quoteBase, location.origin);
    ['variant', 'quantity', 'pack_count'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set('source', placement || 'tablet_product');
    if (state.validQuantity) {
      if (state.variant) {
        url.searchParams.set('variant', String(state.variant.id));
        url.searchParams.set('pack_count', String(state.quantity));
        url.searchParams.set('quantity', String(state.devices));
      } else {
        url.searchParams.set('quantity', String(state.devices));
        url.searchParams.set('selection_pending', '1');
      }
    } else url.searchParams.set('quantity_pending', '1');
    const params = new URLSearchParams(location.search);
    ['preview_theme_id', '_fd', 'pb', 'country', 'currency', 'locale', 'model', 'smartfit_model'].forEach(key => { if (params.has(key)) url.searchParams.set(key, params.get(key)); });
    url.hash = 'avb-quick';
    return url.pathname + url.search + url.hash;
  };
  const sync = strip => {
    if (!strip.isConnected) return;
    const state = current(strip), text = parse(strip.querySelector('[data-av17-bulk-text]')) || {};
    strip.hidden = false;
    const count = state.validQuantity ? new Intl.NumberFormat(document.documentElement.lang || 'en').format(state.devices) : '';
    put(strip.querySelector('[data-av17-bulk-title]'), state.validQuantity && state.devices >= 10 ? interpolate(text.heading_quantity, {count}) : text.heading);
    put(strip.querySelector('[data-av17-bulk-cta-label]'), state.validQuantity && state.devices >= 10 ? interpolate(text.cta_quantity, {count}) : text.cta);
    let status = !state.validQuantity ? text.invalid : !state.variant ? text.help : interpolate(state.packSize > 1 ? text.packs : text.selected, {count, packs: state.quantity, units: state.packSize});
    if (state.variant && !state.variant.available) status += ' ' + text.availability;
    put(strip.querySelector('[data-av17-bulk-status]'), status);
    strip.classList.toggle('av17-bulk--invalid', !state.validQuantity);
    const links = [...strip.querySelectorAll('[data-av17-bulk-link]'), ...document.querySelectorAll('[data-av17-business-inquiry], [data-av17-bulk-placement="sticky"], [data-av17-bulk-placement="price"]')];
    links.forEach(link => {
      if (link.dataset.av17BulkForm && link.dataset.av17BulkForm !== strip.dataset.formId) return;
      link.href = href(strip, state, link.dataset.av17BulkPlacement || 'tablet_product');
    });
    const subtotal = strip.closest('#avontic-primary-product')?.querySelector('[data-av-buybox-subtotal]');
    const stationTotal = strip.closest('[data-station-root]')?.querySelector('[data-station-subtotal]');
    if (stationTotal) {
      stationTotal.hidden = !state.variant || !state.validQuantity;
      if (!stationTotal.hidden) {
        const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:strip.dataset.currency}).format(value / 100);
        put(stationTotal.querySelector('[data-station-total]'), format(state.variant.price * state.quantity));
        put(stationTotal.querySelector('[data-station-unit]'), `${state.quantity} × ${format(state.variant.price)}`);
      }
    }
    if (subtotal && state.packSize > 1) {
      const node = subtotal.querySelector('[data-av17-bulk-pack-price]');
      if (node && state.variant) {
        const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:strip.dataset.currency}).format(value / 100);
        put(node, interpolate(text.pack_price, {price:money(state.variant.price),units:state.packSize,device:money(state.variant.price/state.packSize)}));
      }
    }
    return state;
  };
  let queued = false;
  const refresh = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; document.querySelectorAll('[data-av17-bulk]').forEach(sync); }); } };
  document.addEventListener('input', event => { if (event.target.name === 'quantity') { event.target.setCustomValidity(''); refresh(); } });
  document.addEventListener('change', refresh);
  ['variant:change','product:rerender','shopify:section:load','avontic:purchase-fit-ready'].forEach(name => document.addEventListener(name, refresh));
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-av17-bulk-link], [data-av17-business-inquiry]');
    if (!link) return;
    const strip = link.closest('[data-av17-bulk]') || document.querySelector('[data-av17-bulk]');
    if (!strip) return;
    const state = sync(strip);
    if (!state) return;
    if (!state.validQuantity) {
      event.preventDefault();
      const quantity = state.form?.elements.namedItem('quantity');
      if (quantity) {
        const text = parse(strip.querySelector('[data-av17-bulk-text]')) || {};
        quantity.setCustomValidity(text.invalid || 'Enter a valid quantity.');
        quantity.reportValidity();
        quantity.focus();
      }
      return;
    }
    const preview = new URLSearchParams(location.search).has('preview_theme_id') || ['unpublished','development'].includes(String(window.Shopify?.theme?.role).toLowerCase());
    if (!preview) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'av_team_order_click',placement:link.dataset.av17BulkPlacement || 'tablet_product',units:state.validQuantity ? state.devices : null,product_handle:strip.dataset.productHandle,variant_id:state.variant ? String(state.variant.id) : null});
    }
  }, true);
  const start = () => {
    document.querySelectorAll('[data-av17-bulk]').forEach(sync);
    const root = document.getElementById('main') || document.querySelector('main');
    if (root) new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-av17-bulk], variant-picker, [data-station-root], product-form') || node.querySelector('[data-av17-bulk], variant-picker, [data-station-root], product-form'))))) refresh();
    }).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-av-purchase-fit']});
  };
  window.AvonticBulkOrders = Object.freeze({version:'2026-10-24.1',refresh});
  window.addEventListener('pageshow',refresh);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',start,{once:true}) : start();
})();